import { Box, Button, ButtonSize, Modal, ModalHeader, ModalSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ModalStyled = styled(Modal).attrs({
  size: ModalSize.DEFAULT,
})`
  width: 400px;
  transform: translateY(25%);
`;
export const ModalHeaderStyled = styled(ModalHeader)`
  display: flex;
  align-items: center;
  margin: 0;
  ${({ theme }) => css`
    padding: ${theme.spacings[200]};
    height: ${theme.spacings[800]};
  `}
`;

export const ModalFooterStyled = styled(Box).attrs({
  justifyContent: { sm: 'flex-end' },
})`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
`;
export const FooterButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
})`
  ${({ theme }) => css`
    margin-left: 10px;
    min-width: 96px;
    font-weight: ${theme.fontWeights[600]};
    padding: ${theme.spacings[500]};
  `}
`;
export const ModalCloseStyled = styled(Box)`
  position: absolute;
  ${({ theme }) => css`
    right: ${theme.spacings[400]};
    top: ${theme.spacings[400]};
  `}
`;
